import { Alert, Button, Icon, Spinner } from '@tb/ui';
import { DICTIONARY } from '../i18n/dictionary';
import { detectLocale } from '../i18n/LocaleProvider';

function bootText(key: 'boot.loading' | 'boot.failed' | 'boot.retry'): string {
  return DICTIONARY[key][detectLocale()];
}

export function BootSplash() {
  return (
    <div className="boot">
      <Icon name="ton" size={40} />
      <Spinner size={22} label={bootText('boot.loading')} />
    </div>
  );
}

export function BootError({ message }: { message: string }) {
  return (
    <div className="boot">
      <div className="tb-stack" style={{ maxWidth: 380 }}>
        <Alert tone="danger" title={bootText('boot.failed')}>
          {message}
        </Alert>
        <Button icon="refresh" onClick={() => window.location.reload()}>
          {bootText('boot.retry')}
        </Button>
      </div>
    </div>
  );
}
